import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/Style.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ThemeProvider} from '@emotion/react';

import './i18n';
import {GlobalContextProvider} from './context/GlobalContext';
import theme from './styles/theme';
import {SnackbarProvider} from 'notistack';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.Fragment>
    {/* @ts-ignore */}
    <GlobalContextProvider>
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <SnackbarProvider>
          <App />
        </SnackbarProvider>
      </ThemeProvider>
    </HelmetProvider>
    </GlobalContextProvider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
